// extracted by mini-css-extract-plugin
export default {"contactContainer":"Contact_contactContainer__RMEL4","contactText":"Contact_contactText__qhStS","iconContainer":"Contact_iconContainer__dRxXE","icon":"Contact_icon__uPRlS"};